import React from 'react';
import PropTypes from 'prop-types';
import { RichText, Link } from '@sitecore-jss/sitecore-jss-react';
import { P } from '../../theme/typography';

import {
  ButtonGroup,
} from './css';

const InstructionsTile = (props) => {
  const { fields } = props;
  const primaryLink = fields['primary link'];
  const hasPrimary = primaryLink && primaryLink.value && primaryLink.value.href;
  const secondaryLink = fields['secondary link'];
  const hasSecondary = secondaryLink && secondaryLink.value && secondaryLink.value.href;

  return (
    <>
      <P><RichText tag="p" field={fields.instructions} /></P>
      {(hasPrimary || hasSecondary)
                && (
                <ButtonGroup className="right">
                  {hasSecondary
                        && (
                        <Link field={secondaryLink} className="secondaryButton">
                          <span className="icon" />
                          {secondaryLink.value.text}
                        </Link>
                        )}
                  {hasPrimary
                        && (
                        <Link field={primaryLink} className="primaryButton submit">
                          <span className="icon" />
                          {primaryLink.value.text}
                        </Link>
                        )}
                </ButtonGroup>
                )}
    </>
  );
};

InstructionsTile.propTypes = {
  fields: PropTypes.shape({
    instructions: PropTypes.object,
    'primary link': PropTypes.shape({
      value: PropTypes.shape({
        text: PropTypes.string,
        href: PropTypes.string,
      }),
    }),
    'secondary link': PropTypes.shape({
      value: PropTypes.shape({
        text: PropTypes.string,
        href: PropTypes.string,
      }),
    }),
  }),
};

export default InstructionsTile;
